module.exports = __webpack_public_path__ + "static/media/security_3.c047af1f.png";